export default "__VITE_ASSET__CQa8hqDw__"